import * as ActionTypes from "../constants/actionTypes"
import IAccountData from "../interfaces/watchmen"

function init(): IAccountData {
	return {} as IAccountData
}

export const accountDataReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case ActionTypes.FETCH_ACCOUNT_DATA_SUCCESS:
			return Object.assign({}, action.payload?.data)
		case ActionTypes.UPDATE_USER_ID: {
			const roles = [...initialState.memberships]
			roles[0].userId = action.userId
			return { ...initialState, roles }
		}
		case ActionTypes.UPDATE_ACCOUNT_DATA:
			return {
				...initialState,
				...action.payload,
			}
		default:
			return initialState
	}
}
